export default "__VITE_ASSET__CVJLwWxq__"